<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

interface PaxSelectorButtonWhiteProps {
  buttonText: string;
  childrenAges?: string;
}

const props = defineProps<PaxSelectorButtonWhiteProps>();
</script>

<template>
  <button class="pax-selector-button-white">
    <div class="button-text">
      <span class="pax">{{ props.buttonText }}</span>
      <span v-if="props.childrenAges" class="ages">
        {{ props.childrenAges }}
      </span>
    </div>
    <AppSvgIcon name="chevronDown" />
  </button>
</template>

<style scoped lang="scss">
.pax-selector-button-white {
  display: flex;
  gap: var(--spacing-12);
  height: 100%;
  padding: 0 var(--spacing-32);
  transition: all var(--transition-short);

  @include on-hover {
    cursor: pointer;
    background-color: var(--color-secondary-93);
  }

  .button-text {
    display: flex;
    flex-direction: column;
    text-wrap: nowrap;
    text-align: left;

    .pax {
      @include font-body-m-bold;
      white-space: nowrap;
    }

    .ages {
      @include font-body-m-light;
      color: var(--color-secondary-60);
    }
  }
}
</style>
